import * as i0 from '@angular/core';
import { InjectionToken, NgModule, Self } from '@angular/core';
import * as i1 from '@angular-ru/ngxs/internals';
import { NgxsDataFactory, NgxsDataInjector, NgxsDataSequence } from '@angular-ru/ngxs/internals';
import { ɵprovideNgxsInternalStateTokens as _provideNgxsInternalStateTokens } from '@ngxs/store';

const NGXS_DATA_CONFIG_DEFAULT = {
    dataActionSubscribeRequired: true,
};
const NGXS_DATA_CONFIG = new InjectionToken('NGXS_DATA_CONFIG', {
    providedIn: 'root',
    factory: () => NGXS_DATA_CONFIG_DEFAULT,
});

class NgxsDataPluginModule {
    constructor(accessor, injector) {
        this.accessor = accessor;
        this.injector = injector;
    }
    static forRoot(extensions = []) {
        return {
            ngModule: NgxsDataPluginModule,
            providers: [
                NgxsDataFactory,
                NgxsDataInjector,
                NgxsDataSequence,
                _provideNgxsInternalStateTokens(),
                ...extensions,
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.6", ngImport: i0, type: NgxsDataPluginModule, deps: [{ token: i1.NgxsDataFactory, self: true }, { token: i1.NgxsDataInjector, self: true }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.0.6", ngImport: i0, type: NgxsDataPluginModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.0.6", ngImport: i0, type: NgxsDataPluginModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.6", ngImport: i0, type: NgxsDataPluginModule, decorators: [{
            type: NgModule
        }], ctorParameters: () => [{ type: i1.NgxsDataFactory, decorators: [{
                    type: Self
                }] }, { type: i1.NgxsDataInjector, decorators: [{
                    type: Self
                }] }] });

/**
 * Generated bundle index. Do not edit.
 */

export { NGXS_DATA_CONFIG, NgxsDataPluginModule };
